import { sub } from "../shared/fixed";
import { BUTTON } from "../sim";
import type { Scenario } from "./scenario";
import { HUMAN_FIGHT } from "./humanFight";
import { MOVE_SHEET } from "./moveSheet";

export type { Scenario } from "./scenario";

const SUPER = BUTTON.super | BUTTON.enhance;

function superAt(attackerX: number, facing: number): Scenario {
  return {
    setup: (state) => {
      const [me, other] = state.fighters;
      me.meter = 3000;
      me.x = sub(attackerX);
      me.facing = facing;
      other.x = sub(attackerX + 70 * facing);
      other.facing = -facing;
    },
    input: (frame) => [frame === 2 ? SUPER : 0, 0],
  };
}

export const SCENARIOS: Readonly<Record<string, Scenario>> = {
  ...MOVE_SHEET,
  "human-fight": HUMAN_FIGHT,
  "super-right": superAt(860, 1),
  "super-left": superAt(110, -1),
  "super-center": superAt(440, 1),
};
